import { PF } from '@app/pages/Warehouses/ProductDirectory/data';
import {
  useProductDirectory,
  useProductDirectoryEffects,
} from '@app/pages/Warehouses/ProductDirectory/hooks';
import {
  ProductDirectoryTable,
  Filters,
} from '@app/pages/Warehouses/ProductDirectory/ui';
import { FiltersAccordion } from '@app/shared/components';

import '@pages/Warehouses/ProductDirectory/styles/ProductDirectory.scss';

export const ProductDirectory = () => {
  const {
    onChangeSearchTerm,
    unsavedFilters,
    tableData,
    total,
    isPageLoading,
    isFetching,
    searchProductsHandler,
    onFilterChange,
    skipFilters,
    onSearch,
    onPaginate,
    onPageSizeChange,
    disabledFilters,
    categoryOptions,
    brandsOptions,
    filters,
    columns,
  } = useProductDirectory();

  useProductDirectoryEffects({ searchProductsHandler });

  return (
    <div className={`${PF}_container`}>
      <div className={`${PF}_filters-section`}>
        <FiltersAccordion>
          <Filters
            values={unsavedFilters}
            onChangeSearchTerm={onChangeSearchTerm}
            skipFilters={skipFilters}
            onFilterChange={onFilterChange}
            onSearch={onSearch}
            disabledFilters={disabledFilters}
            categoryOptions={categoryOptions}
            brandsOptions={brandsOptions}
          />
        </FiltersAccordion>
      </div>

      <div className={`${PF}_table-section`}>
        <ProductDirectoryTable
          columns={columns}
          filters={filters}
          isPageLoading={isPageLoading}
          isFetching={isFetching}
          data={tableData}
          total={total}
          onPaginate={onPaginate}
          onPageSizeChange={onPageSizeChange}
        />
      </div>
    </div>
  );
};
